// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__V0If9","white":"FAQ_white__5KdWm","faq_wrapper":"FAQ_faq_wrapper__B3gTb","text-center":"FAQ_text-center__tF3Qv","accordion-body":"FAQ_accordion-body__Pa6la"};